<template>
    <div>
        <FormEdit :data-view-dokumen-pengadaan="data_view_dokumen_pengadaan" action="view"></FormEdit>
    </div>
    
    <div class="field grid" v-show="loadingApproval">
        <div class="col-12">
            <ProgressBar mode="indeterminate" style="height: .5em" />
        </div>
    </div>

</template>

<script>
import axios from 'axios'
import FormEdit from './Penyusunan/FormEdit.vue'

export default {
    name: "Index",
    components: {
        FormEdit,
    },
    props: {
        uuid: String,
        data_view_dokumen_pengadaan: Object,
        errors: Object,
        action : String
    },
    data() {
        return {
            loadingApproval: false,
            submitted: false,
            form_approval: {
                catatan: null,
                approval: null,
            },
            form: {},
        }
    },
    validations() {
        return {
            form_approval: {
                approval: {
                    required,
                },
            },
        }
    },
    methods: {
        approveForm() {
            this.loadingApproval = true
            this.submitted = true

            this.$v.$touch()
            if (this.$v.$invalid) {
                this.loadingApproval = false
                return
            }

            this.form_approval.uuid = this.uuid

            axios.post('/dokumen_pengadaan/approval', this.form_approval)
                .then(response => {
                    if (response.data.success) {
                        this.$toast.add({ severity: 'success', summary: 'Berhasil!', detail: response.data.message, life: 3000 })
                    }

                    this.loadingApproval = false
                    this.$emit('closemodal')
                })
        },
    },
    created() {
        this.form = this.dataViewDokumenPengadaan
    },
}
</script>

<style lang="css" scoped>
.red-radiobutton {
    border-color: #a61900;
}

.red-radiobutton.p-radiobutton-checked .p-radiobutton-box.p-highlight {
    border-color: #a61900 !important;
    background: #a60000 !important;
}
</style> 
